var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "v-multi-slider",
      class: {
        "v-input--disabled": _vm.disabled,
        empty: _vm.value == "",
      },
      style: {
        "--multi-slider-background-color": _vm.backgroundColor,
        "--multi-slider-contrast-color":
          "lch(from var(--multi-slider-background-color) calc((49.44 - l) * infinity) 0 0)",
      },
    },
    [
      _c(
        "div",
        {
          ref: "track",
          staticClass: "v-multi-slider__track-container",
          attrs: { "aria-hidden": "true" },
        },
        _vm._l(_vm.segments, function (segment, idx) {
          return _c("div", {
            key: idx,
            staticClass: "v-multi-slider__track-segment",
            style: _vm.getTrackStyle(segment.start, segment.end),
          })
        }),
        0
      ),
      _vm._v(" "),
      _vm._l(_vm.normalized, function (val, idx) {
        return _c(
          "div",
          {
            key: idx,
            staticClass: "v-multi-slider__thumb",
            class: { active: _vm.selectedIndices.includes(idx) },
            style: _vm.thumbStyle(val),
            on: {
              click: function ($event) {
                return _vm.toggleSelection(idx)
              },
            },
          },
          [
            _c("span", { staticClass: "v-multi-slider__thumb-label" }, [
              _vm._v(_vm._s(_vm.flat_chain[idx] + _vm.flat_pos[idx])),
            ]),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }